import { render, staticRenderFns } from "./ConfigSystemSmtpProperties.vue?vue&type=template&id=6a9687b2&scoped=true&"
import script from "./ConfigSystemSmtpProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigSystemSmtpProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSystemSmtpProperties.vue?vue&type=style&index=0&id=6a9687b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9687b2",
  null
  
)

export default component.exports